import { requests } from "../../../../api/agent"

export default {
	create				: (params) => requests.post('/RePTM/create', params),
	update				: (params) => requests.post('/RePTM/update', params),
	delete				: (params) => requests.getWithParams('/RePTM/delete', params),
	restore				: (params) => requests.getWithParams('/RePTM/restore', params),
	getTree			    : (params) => requests.getWithParams('/RePTM/getTree', params),
	getPagedAll			: (params) => requests.getWithParams('/RePTM/getPagedAll', params),
	getPagedAudit		: (params) => requests.getWithParams('/RePTM/getPagedAudit', params),
	getList				: (params) => requests.getWithParams('/RePTM/getList', params),
	getPtmSecond		: () => requests.get('/rePtm/getPtmSecond'),
	getPtmByIds 	    : (params) => requests.post('/RePTM/getPtmByIds', params)
}